import { BRAND_NAME, logo } from "../app-layout/consts";
export default function Logo({
  size,
  className,
}: {
  size: number;
  className?: string;
}) {
  return (
    <img
      src={logo}
      width={size}
      height={size}
      className={className}
      alt={BRAND_NAME}
    />
  );
}
